import React from 'react';
import { IonTabBar, IonTabButton, IonIcon, IonLabel } from '@ionic/react';
import { closeOutline, homeOutline } from 'ionicons/icons';

interface Props {
  baseUrl?: string;
  className?: string;
  history: any;
}

const TabBar: React.FC<Props> = ({
  baseUrl = '/dashboard',
  className,
  history
}) => {
  const closeDesktopMenu = (push?: string) => {
    document.body.classList.remove('menu-open');
    if (push) {
      history.push(push);
    }
  };

  return (
    <IonTabBar className={className}>
      <IonTabButton className="ion-custom-hide-md-down tab-bar__close">
        <div
          onClick={(e) => {
            e.preventDefault();
            closeDesktopMenu();
          }}
          className="tab-icon-close-event-listener"
        >
          <IonIcon icon={closeOutline}></IonIcon>
        </div>
      </IonTabButton>
      <IonTabButton mode="ios">
        <div
          onClick={(e) => {
            e.preventDefault();
            closeDesktopMenu(`${baseUrl}/resume`);
          }}
          className="tab-icon-event-listener"
        >
          <div className="tab-icon-wrapper">
            <IonIcon icon={homeOutline} />
          </div>
          <IonLabel>Accueil</IonLabel>
        </div>
      </IonTabButton>
      <IonTabButton mode="ios">
        <div
          onClick={(e) => {
            e.preventDefault();
            closeDesktopMenu(`${baseUrl}/mon-compte`);
          }}
          className="tab-icon-event-listener"
        >
          <div className="tab-icon-wrapper">
            <IonIcon src={require('../assets/icons/account.svg')} />
          </div>
          <IonLabel>Mon Compte</IonLabel>
        </div>
      </IonTabButton>
      <IonTabButton mode="ios">
        <div
          onClick={(e) => {
            e.preventDefault();
            closeDesktopMenu(`${baseUrl}/rendez-vous`);
          }}
          className="tab-icon-event-listener"
        >
          <div className="tab-icon-wrapper">
            <IonIcon src={require('../assets/icons/calendar.svg')}></IonIcon>
          </div>
          <IonLabel>Mes Rendez-Vous</IonLabel>
        </div>
      </IonTabButton>
    </IonTabBar>
  );
};

export default TabBar;
